module.exports = __webpack_public_path__ + "static/handbuch-4c627cbc66b516d00ae22eea79c45695.jpg";